<template>
  <div class="dialog-table-button">
    <el-button type="text" @click="handleClick" class="button_text">
      {{ value }}
    </el-button>
    <PgDialogTable
      v-if="visible"
      v-bind="{ visible, ...$attrs, ...$props }"
      v-on="$listeners"
      @close="close"
    ></PgDialogTable>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { beforValueOldActionProps } from '../../../hooks/index'

defineProps({
  value: {
    type: [String, Number],
    default: '',
  },
  appendToBody: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '查看',
  },
  width: {
    type: String,
    default: '1002px',
  },
  height: {
    type: [String, Number],
    default: 400,
  },
  // 是否是选中明细行直接提交
  isSelectSubmit: { type: Boolean, default: false },
  readonly: { type: Boolean, default: true },
  // Table -----------------------------------------------------------
  data: Array,
  // 表格查询 外部补充条件
  dataParameters: Object,
  // 表格-数据请求url
  dataUrl: String,
  // 是否显示icon添加
  isIconSelection: {
    type: Boolean,
    default: false,
  },
  isSelection: {
    type: Boolean,
    default: false,
  },
  // 表格-分页条数[10, 20,...]
  pageSizes: Array,
  // 表格-默认显示条数
  pageSize: {
    type: Number,
    default: 10,
  },
  rowConfig: {
    type: Object,
    default: () => ({ keyField: 'id' }),
  },
  // 表格-code
  columnTableCode: String,
  // 表格-列定义url
  columnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  // 表格-id前缀
  idPrefix: String,
  checkboxConfig: {
    type: Object,
    default: () => ({ checkField: 'checked' }),
  },
  // -----------------------------------------------------------
  successMsgKey: { type: String, default: '' },
  // 高级查询的code
  criteriaCode: String,
  extendData: Object,
  formModel: Object,
  formUrl: String,
  formParam: Object,
  submitUrl: String,
  submitParams: Object,
  submitField: {
    type: String,
    default: 'ids',
  },
  submitFieldId: {
    type: String,
    default: 'id',
  },
  onOK: Function,
  errorRow: String,
  ...beforValueOldActionProps,
})

const visible = ref(false)

const handleClick = () => {
  visible.value = true
}

const close = () => {
  visible.value = false
}
</script>
<style lang="scss">
@import '../style/dialog-table-button.scss';
</style>
